import { prop } from '@lib/style/theme';
import { cleanProps } from '@lib/utils';
import { css } from 'styled-components';
import { unitStrict } from '../unit';

export interface WidthProps {
    w: number | string;
    width: number | string;
}

export const width = (defaultValue?: WidthProps['width']): any => css`
    & {
        width: ${prop(['w', 'width'], defaultValue, unitStrict)};
    }
`;

width.clean = (props): any => cleanProps(props, ['w', 'width']);
